import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';
import { Wrapper } from '~/styles/Wrapper.styled';

export { Wrapper };

export const StyledBreadcrumbs = styled.div`
  & ${Wrapper} {
    padding: 14px var(--gutter);
    padding-bottom: 0;
    font-size: 12px;
    line-height: 1.38;
    white-space: nowrap;

    @media (min-width: 768px) {
      font-size: ${pxtorem(16)};
    }
  }

  & .split {
    margin: 0 .25em;
  }

  & a {
    color: var(--color);
    text-decoration: none;

    ${ desktopHover(`text-decoration: underline;`) }
  }
`;
